const LEAD_STATUSES = Object.freeze({
	NEW: "New",
	CONTACTED: "Contacted",
	PROSPECT: "Prospect",
	TENTATIVE: "Tentative",
	DEFINITE: "Definite",
	LOST: "Lost",
	DOWN: "Turn Down",
});

const LEAD_STATUSES_INFO = Object.freeze({
	PROSPECT: { description: "Viable lead that the hotel is interested in." },
	TENTATIVE: { description: "Contract Sent." },
	DEFINITE: { description: "Contract Signed." },
	LOST: { description: "Business did not get awarded." },
	DOWN: { description: "Regret / Lead is not viable." },
	OTHER: { description: "Other reason." },
});

const STAT_FORMATS = Object.freeze({
	DECIMAL: "decimal",
	CURRENCY: "currency",
	PERCENT: "percent",
});

const BUS_EVENTS = Object.freeze({
	ALERT_TRIGGERED: "ALERT_TRIGGERED",
	LEAD_DOWN: "LEAD_DOWN",
	LEAD_DOWN_SAVED: "LEAD_DOWN_SAVED",
	LEAD_DOWN_CANCELED: "LEAD_DOWN_CANCELED",
	LEAD_UNEXPANDED: "LEAD_UNEXPANDED",
	LEAD_DELETE: "LEAD_DELETE",
	STATS_UPDATED: "STATS_UPDATED",
	DATES_UPDATED: "DATES_UPDATED",
	PTYPE_UPDATED: "PTYPE_UPDATED",
	STATS_O_UPDATED: "STATS_O_UPDATED",
	LEAD_LOST: "LEAD_LOST",
	LEAD_LOST_SAVED: "LEAD_LOST_SAVED",
	LEAD_LOST_CANCELED: "LEAD_LOST_CANCELED",
});

const LEAD_TYPES = Object.freeze({
	INBOUND: "inbound",
	OUTBOUND: "outbound",
});

const PROPERTIES_TYPES = Object.freeze({
	SOCIAL: 11,
	WEDDINGS: 12,
	MEETINGS: 13,
});

const REASONS_TYPE = [
	{ key: 1, value: "Room rate too low" },
	{ key: 2, value: "Food and beverage rate too low" },
	{ key: 3, value: "Venue too small" },
	{ key: 4, value: "Low budget" },
	{ key: 5, value: "No food and beverage" },
	{ key: 6, value: "Meeting space unavailable" },
	{ key: 7, value: "Guest rooms unavailable" },
	{ key: 8, value: "Renovations" },
	{ key: 9, value: "Cancelled" },
	{ key: 11, value: "No customer response" },
	{ key: 10, value: "Other" },
];

const REASONS_TYPE_VISITOR = [
	{ key: 101, value: "Declined" },
	{ key: 102, value: "Cancelled" },
	{ key: 103, value: "No response" },
	{ key: 104, value: "Other" },
];

const REASON_TYPE_LOST = [
	{ key: 1, value: "Canceled/Postponed" },
	{ key: 2, value: "Changed City/Location" },
	{ key: 3, value: "Chose Another Location" },
	{ key: 4, value: "Contractual" },
	{ key: 5, value: "Customer Budget" },
	{ key: 6, value: "Entry Error" },
	{ key: 7, value: "Function Space" },
	{ key: 8, value: "No Customer Response" },
	{ key: 9, value: "Property Physical Attributes" },
	{ key: 10, value: "Room Rate" },
	{ key: 11, value: "Sleeping Rooms" },
	{ key: 12, value: "Other" },
];

const LINECHART_COLORS = [
	{
		name: "Tentative",
		label: "Tentative",
		border: "#FFBA38",
		bg: "rgba(255, 186, 56, 0.1)",
	},
	{
		name: "Definite",
		label: "Definite",
		border: "#4D0F96",
		bg: "rgba(77, 15, 150, 0.9)",
	},
	{
		name: "AllLeads",
		label: "Total Leads",
		border: "#A0A0A0",
		bg: "rgba(200, 200, 200, 0.9)",
	},
];

const BARCHART_COLORS = [
	{
		name: "Definite",
		label: "Definite",
		border: "#4D0F96",
		bg: "rgba(77, 15, 150, 0.9)",
	},
	{
		name: "notDefinite",
		label: "Tentative",
		border: "#A0A0A0",
		bg: "rgba(200, 200, 200, 0.9)",
	},
];

const FILE_HEADERS = {
	id: "Id",
	date: "Date",
	name: "Name",
	email: "Email",
	phone: "Phone",
	company: "Company",
	event_date: "Event Date",
	number_of_attendees: "Number Of Attendees",
	planner_type: "Planner Type",
	budget_range: "Budget Range",
	room_blocks: "Room Blocks",
	catering: "Catering",
	meeting_space: "Meeting Space",
	comments: "Comments",
	lead_extra_id: "Lead Extra Id",
	status: "Status",
	rooms: "Rooms",
	banquet: "Banquet",
	internal_notes: "Internal Notes",
};

export {
	LEAD_STATUSES,
	BUS_EVENTS,
	LEAD_TYPES,
	PROPERTIES_TYPES,
	LINECHART_COLORS,
	BARCHART_COLORS,
	FILE_HEADERS,
	REASONS_TYPE,
	REASONS_TYPE_VISITOR,
	LEAD_STATUSES_INFO,
	STAT_FORMATS,
	REASON_TYPE_LOST,
};



// WEBPACK FOOTER //
// ./src/constants/index.js